import './CountryFlagCard.scss';
import { ReactNode } from 'react';
import AppTooltip from '../AppTooltip/AppTooltip';

interface Props {
  code: string;
  name: string;
  tooltip?: string | ReactNode;
}

const CountryFlagCard = ({ code, name, tooltip }: Props) => {

  const countryFlagCard = (
    <div className="country-flag-card">
      <img alt={name} src={`/images/flags/${code}.png`} />
      <span>{name}</span>
    </div>
  );

  return tooltip ? (
    <AppTooltip title={tooltip} offsetY={-16}>
      {countryFlagCard}
    </AppTooltip>
  ) : (
    countryFlagCard
  );
};

export default CountryFlagCard;